import React, { Component } from 'react';
import ComboFiltros from './ComboFiltros';
import InputFiltros from './InputFiltros';

class ValorDeBusqueda extends Component {
    constructor(props) {
        super(props);
    }


    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip();
    }


    render() {

        const { data, actions } = this.props;
        let arrayFiltros = data.arrayFiltros;
        let options = [{ Descripcion: "Si", Id: 1 }, { Descripcion: "No", Id: 0 }];
        let componente;

        return (
            <div className="VistaInstanciaParametro-Filtros-Contenedor">
                <div>
                    <label className="VistaInstanciaParametro-Filtros-Label-Cabecera">Valor de búsqueda</label>
                </div>

                <div className='VistaInstanciaParametro-Filtros-Valor-Busqueda-Marign-Top' />

                {
                    arrayFiltros?.length > 0 && arrayFiltros.map(filtro => {
                        switch (filtro.instancia.TipoCodigo) {
                            case "SELECT":
                                componente = <div className='VistaInstanciaParametro-Input-Marign-Top'><ComboFiltros error={filtro.error} descripcion="Seleccione..." filtro={"Filtro"} propiedadId={filtro.instancia.PropiedadId} options={filtro.options} selectCombo={actions.selectCombo} optionSeleccionado={filtro.optionSeleccionado}/></div>
                                break;
                            case "CHECK":
                                componente = <div className='VistaInstanciaParametro-Input-Marign-Top'><ComboFiltros error={filtro.error} descripcion="Seleccione..." filtro={"check"} propiedadId={filtro.instancia.PropiedadId} options={options} selectCombo={actions.selectCombo} optionSeleccionado={filtro.optionSeleccionado}/></div>
                                break;
                            default:
                                componente = <div className='VistaInstanciaParametro-Input-Marign-Top'><InputFiltros error={filtro.error} instancia={filtro.instancia} filtroSeleccionado={filtro} actions={actions} errorFormato={filtro.errorFormato} errorFechaInvalida={filtro.errorFechaInvalida} /></div>
                                break;
                        }

                        return <div className='VistaInstanciaParametro-Filtros-Div-ToolTip' 
                            data-toggle="tooltip"
                            key={filtro.instancia.PropiedadId}
                            data-title={filtro.instancia.Tooltip}
                            data-placement="right">
                            {componente}
                        </div>;
                    })
                }
            </div>
        );
    }
}

export default ValorDeBusqueda;